(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3448],{

/***/ 27532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ButtonHierarchy; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11069);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16693);








var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var ButtonHierarchy;
(function(ButtonHierarchy) {
    ButtonHierarchy["Bezeled"] = "bezeled";
    ButtonHierarchy["BezeledGray"] = "bezeled-gray";
    ButtonHierarchy["Borderless"] = "borderless";
    ButtonHierarchy["BorderlessGray"] = "borderless-gray";
    ButtonHierarchy["ChipChoice"] = "chip-choice";
    ButtonHierarchy["ChipFilter"] = "chip-filter";
    ButtonHierarchy["Filled"] = "filled";
    ButtonHierarchy["Outline"] = "outline";
    ButtonHierarchy["Success"] = "success";
    ButtonHierarchy["TabChoice"] = "tab-choice";
    ButtonHierarchy["Text"] = "text";
    ButtonHierarchy["Black"] = "black";
})(ButtonHierarchy || (ButtonHierarchy = {}));
var Button = function(_param) {
    var hierarchy = _param.hierarchy, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, label = _param.label, size = _param.size, _icon = _param.icon, icon = _icon === void 0 ? "" : _icon, _iconPosition = _param.iconPosition, iconPosition = _iconPosition === void 0 ? "left" : _iconPosition, _leadingIcon = _param.leadingIcon, leadingIcon = _leadingIcon === void 0 ? "" : _leadingIcon, _trailingIcon = _param.trailingIcon, trailingIcon = _trailingIcon === void 0 ? "" : _trailingIcon, _isSelected = _param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? true : _hasBackground, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? true : _hasPadding, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? true : _hasTransition, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _theme = _param.theme, theme = _theme === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Theme.light */ .Q2.light : _theme, ariaLabel = _param.ariaLabel, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _hasIcon = _param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, _className = _param.className, className = _className === void 0 ? "" : _className, _type = _param.type, type = _type === void 0 ? "button" : _type, children = _param.children, _loader = _param.loader, loader = _loader === void 0 ? "default" : _loader, _retainWidthOnLoadingState = _param.retainWidthOnLoadingState, retainWidthOnLoadingState = _retainWidthOnLoadingState === void 0 ? false : _retainWidthOnLoadingState, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "hierarchy",
        "disabled",
        "label",
        "size",
        "icon",
        "iconPosition",
        "leadingIcon",
        "trailingIcon",
        "isSelected",
        "hasBackground",
        "hasPadding",
        "hasTransition",
        "hasUnderline",
        "theme",
        "ariaLabel",
        "isSquare",
        "isLoading",
        "hasIcon",
        "className",
        "type",
        "children",
        "loader",
        "retainWidthOnLoadingState"
    ]);
    var commonProps = {
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), " ").concat(className),
        "data-is-square": icon && !label || isSquare.toString(),
        "data-hierarchy": hierarchy,
        "data-selected": isSelected,
        "data-size": size,
        "data-has-transition": isLoading ? false : hasTransition,
        "data-has-icon": hasIcon || !!icon || !!leadingIcon || !!trailingIcon,
        "data-icon-position": iconPosition,
        "data-has-background": hasBackground,
        "data-has-padding": hasPadding,
        "data-theme": theme,
        "aria-label": ariaLabel ? ariaLabel : icon ? icon : label,
        "data-has-underline": hasUnderline,
        "data-is-loading": isLoading,
        "data-retains-width-on-load": retainWidthOnLoadingState,
        disabled: disabled
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps, commonProps), {
        onClick: function(e) {
            if (isLoading) {
                return;
            }
            if (restProps.onClick) {
                restProps.onClick(e);
            }
        },
        type: type,
        children: [
            leadingIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: leadingIcon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            iconPosition === "right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: label
            }),
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: icon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            iconPosition === "left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: label
            }),
            isLoading && (loader === "dots" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-container"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-dots"])
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                customClass: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader),
                name: "Loader2",
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            })),
            trailingIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: trailingIcon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            children
        ]
    }));
};


/***/ }),

/***/ 96732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.B; },
/* harmony export */   "z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27532);



/***/ }),

/***/ 38800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./components/styleguide/NewsletterWidget/index.ts + 1 modules
var NewsletterWidget = __webpack_require__(22705);
// EXTERNAL MODULE: ./components/styleguide/TrustpilotStarWidget/index.ts + 1 modules
var TrustpilotStarWidget = __webpack_require__(87319);
// EXTERNAL MODULE: ./components/styleguide/Footer/footer.module.scss
var footer_module = __webpack_require__(84541);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
// EXTERNAL MODULE: ./lib/utilities/image.js
var utilities_image = __webpack_require__(74398);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./types/system.ts
var types_system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Footer/Footer.tsx

















var FeedbackModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(9575), __webpack_require__.e(302)]).then(__webpack_require__.bind(__webpack_require__, 77624));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77624)
            ];
        }
    }
});
var Footer = function() {
    var router = (0,next_router.useRouter)();
    var currentYear = (0,system/* getCurrentYear */.H8)();
    var isVans = router.asPath.includes(routes/* ROUTES.vanHomePage.url */.Z.vanHomePage.url);
    var vehicleType = isVans ? constants/* FILTER_VEHICLE_TYPES_VANS */.Bz : constants/* FILTER_VEHICLE_TYPES_CARS */.DC;
    var routerAsPathNoPrams = router.asPath.split("?")[0];
    var shouldHideFooter = routerAsPathNoPrams.match(routes/* ROUTES.vehicleConfigPage.regex.van */.Z.vehicleConfigPage.regex.van) || routerAsPathNoPrams.match(routes/* ROUTES.vehicleConfigPage.regex.car */.Z.vehicleConfigPage.regex.car) || routerAsPathNoPrams.match(routes/* ROUTES.enquiryLandingPage.regex */.Z.enquiryLandingPage.regex) || routerAsPathNoPrams.match(routes/* ROUTES.enquiryLandingAltPage.regex */.Z.enquiryLandingAltPage.regex) || routerAsPathNoPrams.match(routes/* ROUTES.locoAiSearchPage.regex */.Z.locoAiSearchPage.regex);
    var shouldShowSellYourVehicleMarks = router.asPath.match(routes/* ROUTES.homePage.regex */.Z.homePage.regex) || router.asPath.match(routes/* ROUTES.vanHomePage.regex */.Z.vanHomePage.regex) || router.asPath.match(routes/* ROUTES.vehicleDealsPage.regex.van */.Z.vehicleDealsPage.regex.van) || router.asPath.match(routes/* ROUTES.vehicleDealsPage.regex.car */.Z.vehicleDealsPage.regex.car) || router.asPath.match(routes/* ROUTES.vehicleConfigPage.regex.van */.Z.vehicleConfigPage.regex.van) || router.asPath.match(routes/* ROUTES.vehicleConfigPage.regex.car */.Z.vehicleConfigPage.regex.car) || router.asPath.match(routes/* ROUTES.vehicleEnquiredPage.regex.car */.Z.vehicleEnquiredPage.regex.car) || router.asPath.match(routes/* ROUTES.vehicleEnquiredPage.regex.van */.Z.vehicleEnquiredPage.regex.van);
    var shouldShowInsuranceMarks = router.asPath.match(routes/* ROUTES.homePage.regex */.Z.homePage.regex) || router.asPath.match(routes/* ROUTES.vanHomePage.regex */.Z.vanHomePage.regex) || router.asPath.match(routes/* ROUTES.vehicleDealsPage.regex.van */.Z.vehicleDealsPage.regex.van) || router.asPath.match(routes/* ROUTES.vehicleDealsPage.regex.car */.Z.vehicleDealsPage.regex.car) || router.asPath.match(routes/* ROUTES.vehicleConfigPage.regex.van */.Z.vehicleConfigPage.regex.van) || router.asPath.match(routes/* ROUTES.vehicleConfigPage.regex.car */.Z.vehicleConfigPage.regex.car) || router.asPath.match(routes/* ROUTES.vehicleEnquiredPage.regex.car */.Z.vehicleEnquiredPage.regex.car) || router.asPath.match(routes/* ROUTES.vehicleEnquiredPage.regex.van */.Z.vehicleEnquiredPage.regex.van);
    var shouldShowPcpSavingsMarks = router.asPath.match(routes/* ROUTES.homePage.regex */.Z.homePage.regex) || router.asPath.match(routes/* ROUTES.vanHomePage.regex */.Z.vanHomePage.regex);
    var shouldShowBlackFridayMarks = false;
    var onClickSocialLink = function(link) {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "footer",
            action: "social-icon-click",
            link: link
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "".concat((footer_module_default()).main, " ").concat(shouldHideFooter ? (footer_module_default()).hide : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (footer_module_default()).trustpilot,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustpilotStarWidget/* TrustpilotStarWidget */.$, {
                            theme: "light"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (footer_module_default()).stacked,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (footer_module_default()).social,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterWidget/* NewsletterWidget */.X, {
                                        isInline: true,
                                        hasLargeTitle: true,
                                        location: "footer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (footer_module_default()).accounts,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ExternalLink */.d, {
                                                    href: "https://www.facebook.com/leaseloco/",
                                                    target: "_blank",
                                                    title: "Facebook",
                                                    rel: "noopener noreferrer",
                                                    className: (footer_module_default()).facebook,
                                                    onClick: function() {
                                                        return onClickSocialLink("facebook");
                                                    },
                                                    hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                                    size: types_system/* Size.ExtraLarge */.$u.ExtraLarge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "27",
                                                            height: "27",
                                                            alt: "Facebook",
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/facebook.svg")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "LeaseLoco Facebook Page"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ExternalLink */.d, {
                                                    href: "https://www.instagram.com/leaseloco",
                                                    target: "_blank",
                                                    title: "Instagram",
                                                    rel: "noopener noreferrer",
                                                    className: (footer_module_default()).instagram,
                                                    onClick: function() {
                                                        return onClickSocialLink("instagram");
                                                    },
                                                    hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                                    size: types_system/* Size.ExtraLarge */.$u.ExtraLarge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "24",
                                                            height: "24",
                                                            alt: "Instagram",
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/instagram.svg")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "LeaseLoco Instagram Page"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ExternalLink */.d, {
                                                    href: "https://www.twitter.com/leaseloco",
                                                    target: "_blank",
                                                    title: "X (formerly Twitter)",
                                                    rel: "noopener noreferrer",
                                                    className: (footer_module_default()).x,
                                                    onClick: function() {
                                                        return onClickSocialLink("twitter");
                                                    },
                                                    hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                                    size: types_system/* Size.ExtraLarge */.$u.ExtraLarge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "25",
                                                            height: "22",
                                                            alt: "X (formerly Twitter)",
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/twitter-x.svg")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "LeaseLoco X Page"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ExternalLink */.d, {
                                                    href: "https://www.youtube.com/leaseloco",
                                                    target: "_blank",
                                                    title: "YouTube",
                                                    rel: "noopener noreferrer",
                                                    className: (footer_module_default()).youtube,
                                                    onClick: function() {
                                                        return onClickSocialLink("youtube");
                                                    },
                                                    hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                                    size: types_system/* Size.ExtraLarge */.$u.ExtraLarge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "30",
                                                            height: "21",
                                                            alt: "YouTube",
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/youtube.svg")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "LeaseLoco YouTube Page"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ExternalLink */.d, {
                                                    href: "https://www.linkedin.com/company/leaseloco",
                                                    target: "_blank",
                                                    title: "LinkedIn",
                                                    rel: "noopener noreferrer",
                                                    className: (footer_module_default()).linkedin,
                                                    onClick: function() {
                                                        return onClickSocialLink("linkedin");
                                                    },
                                                    hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                                    size: types_system/* Size.ExtraLarge */.$u.ExtraLarge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "25",
                                                            height: "25",
                                                            alt: "LinkedIn",
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/linkedin.svg")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "LeaseLoco LinkedIn Page"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ExternalLink */.d, {
                                                    href: "https://www.tiktok.com/@leaseloco",
                                                    target: "_blank",
                                                    title: "TikTok",
                                                    rel: "noopener noreferrer",
                                                    className: (footer_module_default()).tiktok,
                                                    onClick: function() {
                                                        return onClickSocialLink("tiktok");
                                                    },
                                                    hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                                    size: types_system/* Size.ExtraLarge */.$u.ExtraLarge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "24",
                                                            height: "28",
                                                            alt: "tiktok",
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/tiktok.svg")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "LeaseLoco TikTok Page"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (footer_module_default()).navigation,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (footer_module_default()).list,
                                        children: [
                                            constants/* constants.footer.firstColumn.map */._G.footer.firstColumn.map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: item.slug,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (footer_module_default()).link,
                                                            children: item.label
                                                        })
                                                    })
                                                }, item.slug);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: (footer_module_default()).link,
                                                    onClick: function() {
                                                        return esm/* default.show */.ZP.show(FeedbackModal);
                                                    },
                                                    children: "Contact us"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: (footer_module_default()).link,
                                                    onClick: function() {
                                                        return esm/* default.show */.ZP.show(FeedbackModal, {
                                                            isAdvertisingModal: true
                                                        });
                                                    },
                                                    children: "Advertise with us"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (footer_module_default()).list,
                                        children: constants/* constants.footer.secondColumn.map */._G.footer.secondColumn.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.slug,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (footer_module_default()).link,
                                                        children: item.label
                                                    })
                                                })
                                            }, item.slug);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (footer_module_default()).popular,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Popular lease searches:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (footer_module_default()).list,
                                children: constants/* constants.footerLinks.filter */._G.footerLinks.filter(function(item) {
                                    return item.vehicleType === vehicleType;
                                }).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            hasBackground: true,
                                            hasPadding: true,
                                            href: item.slug,
                                            hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                            size: types_system/* Size.Medium */.$u.Medium,
                                            children: item.label
                                        })
                                    }, item.slug);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (footer_module_default()).legal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (footer_module_default()).list,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            href: routes/* ROUTES.privacyPolicyPage.url */.Z.privacyPolicyPage.url,
                                            hasUnderline: true,
                                            hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                            size: types_system/* Size.Medium */.$u.Medium,
                                            children: "Privacy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            href: routes/* ROUTES.termsPage.url */.Z.termsPage.url,
                                            hasUnderline: true,
                                            hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                            size: types_system/* Size.Medium */.$u.Medium,
                                            children: "Terms"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            href: routes/* ROUTES.cookiePolicyPage.url */.Z.cookiePolicyPage.url,
                                            hasUnderline: true,
                                            hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                            size: types_system/* Size.Medium */.$u.Medium,
                                            children: "Cookies"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            href: routes/* ROUTES.complaintsPage.url */.Z.complaintsPage.url,
                                            hasUnderline: true,
                                            hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                            size: types_system/* Size.Medium */.$u.Medium,
                                            children: "Complaints procedures"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            href: routes/* ROUTES.treatingCustomersFairlyPage.url */.Z.treatingCustomersFairlyPage.url,
                                            hasUnderline: true,
                                            hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                            size: types_system/* Size.Medium */.$u.Medium,
                                            children: "Treatment of customers"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "".concat((footer_module_default()).affiliates, " ").concat((footer_module_default()).list),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.bvrla.co.uk",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/bvrla-logo-dark.svg"),
                                                alt: "British Vehicle Rental & Leasing Association (BVRLA)",
                                                placeholder: "blur",
                                                blurDataURL: "data:image/svg+xml;base64,".concat((0,utilities_image/* toBase64 */.s)((0,utilities_image/* shimmer */.f)(86, 48))),
                                                width: "86",
                                                height: "48"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.cap-hpi.com",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/solera-logo-dark.svg"),
                                                alt: "Solera",
                                                className: "image--cap",
                                                placeholder: "blur",
                                                blurDataURL: "data:image/svg+xml;base64,".concat((0,utilities_image/* toBase64 */.s)((0,utilities_image/* shimmer */.f)(280, 32))),
                                                height: "32",
                                                width: "280"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (footer_module_default()).additional,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Leaseloco Ltd is authorised and regulated by the Financial Conduct Authority in relation to consumer credit. Our FCA number is ",
                                    constants/* constants.financialConductAuthority */._G.financialConductAuthority,
                                    ". We are a credit broker and not a lender and may introduce you to one of a number of companies offering consumer hire or consumer hire-purchase. Leaseloco Ltd is registered in Scotland (",
                                    constants/* constants.companiesHouseNumber */._G.companiesHouseNumber,
                                    "), address: ",
                                    constants/* constants.companyAddress */._G.companyAddress,
                                    ". Data Protection Number: ",
                                    constants/* constants.dataProtectionNumber */._G.dataProtectionNumber,
                                    ". VAT Number: ",
                                    constants/* constants.vatNumber */._G.vatNumber,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Copyright \xa9 2017 - ",
                                    currentYear,
                                    " Leaseloco Ltd. All Rights Reserved."
                                ]
                            }),
                            shouldShowSellYourVehicleMarks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "1"
                                    }),
                                    " 84% of Motorway sellers sold their vehicle for more than the average market price valuation between Jan 2020 and October 2023 (based on two independent market pricing guides)."
                                ]
                            }),
                            shouldShowPcpSavingsMarks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "2"
                                    }),
                                    " Our users saved over \xa330m based on all message enquiries on LeaseLoco on March 2024, when compared to estimated PCP monthly payments over the same term."
                                ]
                            }),
                            shouldShowInsuranceMarks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "3"
                                    }),
                                    " 51% of consumers could achieve this saving with LeaseLoco, in partnership with MoneySuperMarket. Based on Online independent research by Consumer Intelligence during 1st Jan to 31st Jan 2025."
                                ]
                            }),
                            shouldShowBlackFridayMarks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "*"
                                    }),
                                    " Terms & conditions apply. See",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                        href: routes/* ROUTES.termsPage.url */.Z.termsPage.url,
                                        hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                                        size: types_system/* Size.ExtraSmall */.$u.ExtraSmall,
                                        hasUnderline: true,
                                        children: "https://www.leaseloco.com/terms"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (footer_module_default()).ring
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Footer/index.ts



/***/ }),

/***/ 23273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ InternalLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11069);
/* harmony import */ var _Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14327);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_link_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96732);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16693);











var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var InternalLink = function(_param) {
    var children = _param.children, _hierarchy = _param.hierarchy, hierarchy = _hierarchy === void 0 ? _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__/* .ButtonHierarchy.Borderless */ .B.Borderless : _hierarchy, _size = _param.size, size = _size === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Medium */ .$u.Medium : _size, _className = _param.className, className = _className === void 0 ? "" : _className, icon = _param.icon, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? false : _hasPadding, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? false : _hasBackground, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? false : _hasTransition, _hasIcon = _param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, _isFullWidth = _param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, _theme = _param.theme, theme = _theme === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Theme.light */ .Q2.light : _theme, onClick = _param.onClick, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children",
        "hierarchy",
        "size",
        "className",
        "icon",
        "hasPadding",
        "hasBackground",
        "hasUnderline",
        "hasTransition",
        "hasIcon",
        "isFullWidth",
        "isSquare",
        "theme",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, restProps), {
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "".concat((_Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9___default().main), " ").concat((_link_module_scss__WEBPACK_IMPORTED_MODULE_10___default().link), " ").concat(className, " ").concat(isFullWidth ? (_link_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["is-full-width"]) : ""),
            "data-hierarchy": hierarchy,
            "data-is-square": isSquare,
            "data-has-underline": hasUnderline,
            "data-has-background": hasBackground,
            "data-has-transition": hasTransition,
            "data-has-padding": hasPadding,
            "data-has-icon": !!icon || hasIcon,
            "data-size": size,
            onClick: onClick,
            "data-theme": theme,
            children: [
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    name: icon,
                    size: size === _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Medium */ .$u.Medium
                }),
                children
            ]
        })
    }));
};


/***/ }),

/***/ 63383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ ExternalLink; },
  "h": function() { return /* reexport */ InternalLink/* InternalLink */.h; }
});

// EXTERNAL MODULE: ./components/styleguide/Link/InternalLink.tsx
var InternalLink = __webpack_require__(23273);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Button/button.module.scss
var button_module = __webpack_require__(11069);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
// EXTERNAL MODULE: ./components/styleguide/Link/link.module.scss
var link_module = __webpack_require__(14327);
var link_module_default = /*#__PURE__*/__webpack_require__.n(link_module);
;// CONCATENATED MODULE: ./components/styleguide/Link/ExternalLink.tsx










var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var ExternalLink = function(_param) {
    var children = _param.children, _hierarchy = _param.hierarchy, hierarchy = _hierarchy === void 0 ? Button/* ButtonHierarchy.Borderless */.B.Borderless : _hierarchy, _size = _param.size, size = _size === void 0 ? system/* Size.Medium */.$u.Medium : _size, _className = _param.className, className = _className === void 0 ? "" : _className, icon = _param.icon, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? false : _hasPadding, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? false : _hasBackground, _theme = _param.theme, theme = _theme === void 0 ? system/* Theme.light */.Q2.light : _theme, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? false : _hasTransition, _isFullWidth = _param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "hierarchy",
        "size",
        "className",
        "icon",
        "hasPadding",
        "hasBackground",
        "theme",
        "hasUnderline",
        "hasTransition",
        "isFullWidth",
        "isSquare"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "".concat((button_module_default()).main, " ").concat(className, " ").concat(isFullWidth ? (link_module_default())["is-full-width"] : ""),
        "data-hierarchy": hierarchy,
        "data-is-square": isSquare,
        "data-has-underline": hasUnderline,
        "data-has-background": hasBackground,
        "data-has-transition": hasTransition,
        "data-has-padding": hasPadding,
        "data-size": size,
        "data-theme": theme
    }, restProps), {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                name: icon,
                size: size === system/* Size.Large */.$u.Large ? system/* Size.Large */.$u.Large : system/* Size.Medium */.$u.Medium
            }),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./components/styleguide/Link/index.ts




/***/ }),

/***/ 22705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ NewsletterWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/services/userService.js + 1 modules
var userService = __webpack_require__(24989);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/actions/event.js
var actions_event = __webpack_require__(61748);
// EXTERNAL MODULE: ./components/styleguide/NewsletterWidget/newsletter-widget.module.scss
var newsletter_widget_module = __webpack_require__(504);
var newsletter_widget_module_default = /*#__PURE__*/__webpack_require__.n(newsletter_widget_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/TextInput/index.ts
var TextInput = __webpack_require__(32447);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/NewsletterWidget/NewsletterWidget.tsx



















var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var RecaptchaModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9418), __webpack_require__.e(193)]).then(__webpack_require__.bind(__webpack_require__, 193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(193)
            ];
        }
    }
});
var NewsletterWidget = function(param) {
    var _isInline = param.isInline, isInline = _isInline === void 0 ? false : _isInline, _hasLargeTitle = param.hasLargeTitle, hasLargeTitle = _hasLargeTitle === void 0 ? false : _hasLargeTitle, location = param.location;
    var newsletterFormSchema = index_esm/* object */.Ry({
        newsletterEmail: index_esm/* string */.Z_().email("Please enter a valid email address").required("Your email address is required")
    });
    var ref = (0,react.useState)(constants/* constants.componentStatus.DEFAULT */._G.componentStatus.DEFAULT), subscribeStatus = ref[0], setSubscribeStatus = ref[1];
    var isDesktop = (0,react_responsive.useMediaQuery)({
        query: "(min-width: 992px)"
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var onSubmitForm = function(values) {
        esm/* default.show */.ZP.show(RecaptchaModal).then(function(value) {
            (0,userService/* sendNewsletterDetailsService */.gQ)({
                emailAddress: values.newsletterEmail,
                "g-recaptcha-response": value
            }).then(function(res) {
                if (res.error) {
                    setSubscribeStatus(constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR);
                } else {
                    setSubscribeStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE);
                    (0,react_toastify_esm/* toast */.Am)("Successfully signed up for newsletter");
                    (0,vehicle/* addToDataLayer */.Bk)({
                        event: "user-newsletter-signup",
                        label: location
                    });
                    dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                        event: constants/* constants.eventTypes.newsletterSignup */._G.eventTypes.newsletterSignup,
                        payload: {
                            formType: "widget",
                            emailAddressOnly: false
                        }
                    }));
                    if (typeof window.ttq !== "undefined") {
                        window.ttq.track("Subscribe", {
                            // eslint-disable-next-line camelcase
                            content_id: "Newsletter subscribe",
                            // eslint-disable-next-line camelcase
                            content_type: "product",
                            // eslint-disable-next-line camelcase
                            content_name: "Newsletter subscribe",
                            quantity: 1,
                            value: null,
                            price: null,
                            currency: "GBP"
                        });
                    }
                }
            }).catch(function(e) {
                (0,esm_exports/* captureException */.Tb)("Failed to sign up to newsletter", e);
                setSubscribeStatus(constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR);
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (newsletter_widget_module_default()).main,
        "data-is-inline": isInline,
        children: [
            hasLargeTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (newsletter_widget_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "".concat((newsletter_widget_module_default()).title, " ").concat((newsletter_widget_module_default()).large),
                    children: "Sign up for exclusive deals, Loco updates, latest news and more."
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (newsletter_widget_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (newsletter_widget_module_default()).title,
                        children: "Sign up for our newsletter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (newsletter_widget_module_default()).paragraph,
                        children: "Get news, car tips & hottest offers"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (newsletter_widget_module_default())["form-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    validationSchema: newsletterFormSchema,
                    enableReinitialize: true,
                    validateOnChange: false,
                    validateOnBlur: false,
                    initialValues: {
                        newsletterEmail: ""
                    },
                    onSubmit: function(values) {
                        return onSubmitForm(values);
                    },
                    children: function(param) {
                        var handleSubmit = param.handleSubmit;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            className: (newsletter_widget_module_default()).form,
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                id: "newsletterEmail",
                                placeholder: "Enter your email".concat(isDesktop ? " address" : ""),
                                name: "email",
                                autoComplete: "email",
                                disabled: subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE,
                                button: {
                                    size: system/* Size.Medium */.$u.Medium,
                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                    theme: system/* Theme.light */.Q2.light,
                                    label: "Subscribe",
                                    type: "submit",
                                    className: !(0,utilities_system/* isProd */.BB)() ? "newsletter__subscribe-button" : ""
                                }
                            })
                        });
                    }
                })
            }),
            (subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE || subscribeStatus === constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-state": subscribeStatus,
                className: (newsletter_widget_module_default()).notification,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        customClass: (newsletter_widget_module_default())["notification--icon"],
                        name: subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE ? "CheckCircle2" : "Info",
                        size: system/* Size.Medium */.$u.Medium
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (newsletter_widget_module_default())["notification--text"],
                        children: subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE ? "Great, you'll get the first email soon" : "We were unable to sign your email up. Please try again later."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/NewsletterWidget/index.ts



/***/ }),

/***/ 77786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80969);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96732);
/* harmony import */ var _text_input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98547);
/* harmony import */ var _text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16693);









var TextInput = function(param) {
    var label = param.label, hint = param.hint, id = param.id, placeholder = param.placeholder, button = param.button, disabled = param.disabled, visual = param.visual, type = param.type, required = param.required, inputMode = param.inputMode, pattern = param.pattern, _hideHintText = param.hideHintText, hideHintText = _hideHintText === void 0 ? false : _hideHintText, min = param.min, max = param.max, passwordrules = param.passwordrules, inputPrefixNode = param.inputPrefixNode, _className = param.className, className = _className === void 0 ? "" : _className, _classNameBox = param.classNameBox, classNameBox = _classNameBox === void 0 ? "" : _classNameBox, maxLength = param.maxLength;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_5__/* .useField */ .U$)({
        name: id
    }), 2), field = ref[0], meta = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main), " ").concat(className),
        "data-visual": visual,
        "data-input-type": type,
        "data-disabled": disabled || visual === true,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: id,
                className: (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                children: [
                    label,
                    required && "*"
                ]
            }),
            inputPrefixNode,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "input-box ".concat((_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box), " ").concat(button && button.label ? (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["with-button"]) : "", " ").concat(classNameBox),
                "data-error": !!meta.error,
                onClick: function() {
                    var ref;
                    return (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        id: id,
                        className: (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input),
                        placeholder: placeholder,
                        disabled: disabled || visual === true,
                        ref: inputRef,
                        type: type,
                        inputMode: inputMode,
                        pattern: pattern
                    }, field), {
                        min: min,
                        max: max,
                        maxLength: maxLength,
                        passwordrules: passwordrules
                    })),
                    button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, button), {
                        hierarchy: _Button__WEBPACK_IMPORTED_MODULE_2__/* .ButtonHierarchy.Filled */ .B.Filled,
                        disabled: disabled,
                        theme: button.theme ? button.theme : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Theme.dark */ .Q2.dark
                    }))
                ]
            }),
            !hideHintText && (hint || meta.error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().foot),
                "data-error": !!meta.error,
                children: meta.error || hint
            })
        ]
    });
};


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _TextInput__WEBPACK_IMPORTED_MODULE_0__.o; }
/* harmony export */ });
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77786);



/***/ }),

/***/ 87319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ TrustpilotStarWidget; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/styleguide/TrustpilotStarWidget/trustpilot.module.scss
var trustpilot_module = __webpack_require__(14667);
var trustpilot_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/styleguide/TrustpilotStarWidget/TrustpilotStarWidget.tsx






var TrustpilotStarWidget = function(param) {
    var _theme = param.theme, theme = _theme === void 0 ? "light" : _theme;
    var widgetRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "0px 0px 100px 0px"
        });
        if (widgetRef.current) {
            observer.observe(widgetRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isVisible && window.Trustpilot && widgetRef.current) {
            window.Trustpilot.loadFromElement(widgetRef.current);
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: widgetRef,
        className: (trustpilot_module_default()).trustpilot,
        children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                    strategy: "lazyOnload"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: widgetRef,
                    className: "trustpilot-widget",
                    "data-locale": "en-GB",
                    "data-template-id": constants/* constants.trustpilot.templates.MICRO_STAR.id */._G.trustpilot.templates.MICRO_STAR.id,
                    "data-businessunit-id": constants/* constants.trustpilot.businessUnitId */._G.trustpilot.businessUnitId,
                    "data-style-height": constants/* constants.trustpilot.templates.MICRO_STAR.height */._G.trustpilot.templates.MICRO_STAR.height,
                    "data-style-width": "100%",
                    "data-theme": theme
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/TrustpilotStarWidget/index.ts



/***/ }),

/***/ 7158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
var ROUTES = {
    accountDetailsPage: {
        url: "/locospace/account-details",
        regex: /\/locospace\/account-details/
    },
    authPage: {
        url: "/auth",
        regex: /\/auth/
    },
    autoResetPasswordPage: {
        url: "/password/reset/:username/:verificationCode"
    },
    autoVerifyPage: {
        url: "/verify/:username/:verificationCode",
        regex: /\/verify\/(.+)\/([0-9]{0,10})$/
    },
    blogPage: {
        url: "/blog"
    },
    blogArticlePage: {
        url: "/blog/:slug"
    },
    businessLeasingPage: {
        url: "/business-leasing"
    },
    careersPage: {
        url: "/careers"
    },
    carSearchPage: {
        url: "/car-leasing/search",
        regex: /\/car-leasing\/search/
    },
    collectionsPage: {
        url: "/collections",
        regex: /\/collections/,
        title: "collections"
    },
    comparisonPage: {
        url: "/locospace/comparison",
        regex: /\/locospace\/comparison/
    },
    complaintsPage: {
        url: "/complaints"
    },
    cookiePolicyPage: {
        url: "/cookie-policy"
    },
    debugPage: {
        url: "/debug"
    },
    electricVehiclesPage: {
        url: "/electric-car-leasing"
    },
    ethicalCodeOfConductPage: {
        url: "/ethical-code-of-conduct"
    },
    enquiriesPage: {
        url: "/locospace/enquiries",
        regex: /\/locospace\/enquiries/
    },
    enquiryLandingPage: {
        url: "/ad/deal/:adReference",
        regex: /\/ad\/deal\/([a-z0-9-]{0,36})$/
    },
    enquiryLandingAltPage: {
        url: "/ad/deal-alt/:adReference",
        regex: /\/ad\/deal-alt\/([a-z0-9-]{0,36})$/
    },
    faqsPage: {
        url: "/faqs",
        regex: /\/faqs$/
    },
    faqsArticlePage: {
        url: "/faqs/:article"
    },
    forgotPasswordPage: {
        url: "/password"
    },
    guidesArticlePage: {
        url: "/guides/:category/:article",
        regex: /\/guides\/([a-z \w-]{0,50})\/([a-z \w-]{0,50})$/
    },
    guidesPage: {
        url: "/guides",
        regex: /\/guides/
    },
    guidesCategoryPage: {
        url: "/guides/:category",
        regex: /\/guides\/([a-z \w-]{0,50})$/
    },
    homePage: {
        url: "/",
        regex: /^\/$/
    },
    leasingCategoriesPage: {
        url: "/leasing-categories"
    },
    locoScorePage: {
        url: "/loco-score"
    },
    loginPage: {
        url: "/login"
    },
    logoutPage: {
        url: "/logout",
        regex: /\/logout$/
    },
    locoAiSearchPage: {
        url: "/loco-ai/search",
        regex: /\/loco-ai\/search/
    },
    manufacturerLandingPage: {
        url: "/:vehicleType-leasing/:manufacturer",
        regex: {
            default: /\/car-leasing\/(?!search)([a-z \w-]{0,50})$/,
            withPageNumber: /\/car-leasing\/(?!search)([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/(?!search)([a-z \w-]{0,50})$/,
            vanWithPageNumber: /\/van-leasing\/(?!search)([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/
        }
    },
    newsletterSignUpPage: {
        url: "/newsletter/sign-up"
    },
    partnerCriteriaPage: {
        url: "/partner-criteria"
    },
    pcpSavingsPage: {
        url: "/pcp-savings"
    },
    personalCarLeasingPage: {
        url: "/personal-car-leasing"
    },
    privacyPolicyPage: {
        url: "/privacy-policy"
    },
    priceAlertsPage: {
        url: "/locospace/price-alerts",
        regex: /\/locospace\/price-alerts/
    },
    radioPage: {
        url: "/radio"
    },
    rangeLandingPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model",
        regex: {
            default: /\/car-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            withPageNumber: /\/car-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            vanWithPageNumber: /\/van-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/
        }
    },
    referAFriendPage: {
        url: "/locospace/refer-a-friend",
        regex: /\/locospace\/refer-a-friend/
    },
    referAFriendTermsPage: {
        url: "/locospace/refer-a-friend/terms"
    },
    referRegisterPage: {
        url: "/refer/:referralCode",
        regex: /\/refer\/([a-z0-9 \w-]{0,20})$/
    },
    registerPage: {
        url: "/register"
    },
    rewardsPage: {
        url: "/locospace/rewards",
        regex: /\/locospace\/rewards/
    },
    rewardsAndReferralsPage: {
        url: "/rewards-and-referrals",
        regex: /\/rewards-and-referrals$/
    },
    rewardsTermsPage: {
        url: "/locospace/rewards/terms"
    },
    savedSearchPage: {
        url: "/locospace/saved-searches",
        regex: /\/locospace\/saved-searches/
    },
    searchPage: {
        url: "/:vehicleType-leasing/search",
        regex: {
            default: /\/car-leasing\/search$/,
            withPageNumber: /\/car-leasing\/search(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search$/,
            vanWithPageNumber: /\/van-leasing\/search(\?page=([0-9]{1,10}))$/
        }
    },
    searchPageWithReference: {
        url: "/:vehicleType-leasing/search/:reference",
        regex: {
            default: /\/car-leasing\/search\/([a-z0-9 \w-]{0,32})$/,
            withPageNumber: /\/car-leasing\/search\/([a-z0-9 \w-]{0,32})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search\/([a-z0-9 \w-]{0,32})$/,
            vanWithPageNumber: /\/van-leasing\/search\/([a-z0-9 \w-]{0,32})(\?page=([0-9]{1,10}))$/
        }
    },
    searchPageWithManufacturer: {
        url: "/:vehicleType-leasing/search/:manufacturer",
        regex: {
            default: /\/car-leasing\/search\/([a-z \w-]{0,50})$/,
            withPageNumber: /\/car-leasing\/search\/([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search\/([a-z \w-]{0,50})$/,
            vanWithPageNumber: /\/van-leasing\/search\/([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/
        }
    },
    searchPageWithModel: {
        url: "/:vehicleType-leasing/search/:manufacturer/:model",
        regex: {
            default: /\/car-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            withPageNumber: /\/car-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            vanWithPageNumber: /\/van-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/
        }
    },
    termsPage: {
        url: "/terms"
    },
    treatingCustomersFairlyPage: {
        url: "/treating-customers-fairly"
    },
    tvPage: {
        url: "/tv",
        regex: /\/tv$/
    },
    vanHomePage: {
        url: "/van-leasing",
        regex: /\/van-leasing$/
    },
    vanSearchPage: {
        url: "/van-leasing/search",
        regex: /\/van-leasing\/search/
    },
    vehicleWithLeaseProfilePage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})$/
        }
    },
    vehicleWithLeaseProfileAndDealIdPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})$/
        }
    },
    vehicleConfigPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId/config",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/config$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/config$/
        },
        title: {
            car: "car-config",
            van: "van-config"
        }
    },
    vehicleDealsPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId/deals",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/deals$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/deals$/
        },
        title: {
            car: "car-deals",
            van: "van-deals"
        }
    },
    vehicleEnquiredPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId/enquired",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/enquired$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/enquired$/
        },
        title: {
            car: "car-enquired",
            van: "van-enquired"
        }
    },
    verifyEnquiryPage: {
        url: "/verify-enquiry/:type/:id",
        regex: /\/verify-enquiry\/p|e\/([a-z0-9 \w-]{0,6})$/
    },
    whyLeasePage: {
        url: "/why-lease",
        regex: /\/why-lease$/
    }
};


/***/ }),

/***/ 74398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ shimmer; },
/* harmony export */   "s": function() { return /* binding */ toBase64; }
/* harmony export */ });
var shimmer = function(w, h) {
    return '\n  <svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <defs>\n      <linearGradient id="g">\n        <stop stop-color="#333" offset="20%" />\n        <stop stop-color="#222" offset="50%" />\n        <stop stop-color="#333" offset="70%" />\n      </linearGradient>\n    </defs>\n    <rect width="').concat(w, '" height="').concat(h, '" fill="#333" />\n    <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n    <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n  </svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};


/***/ }),

/***/ 16693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$u": function() { return /* binding */ Size; },
/* harmony export */   "Q2": function() { return /* binding */ Theme; },
/* harmony export */   "ih": function() { return /* binding */ TestStatus; }
/* harmony export */ });
/* unused harmony export LoadingStatus */
var Theme;
(function(Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})(Theme || (Theme = {}));
var TestStatus;
(function(TestStatus) {
    TestStatus["Default"] = "default";
    TestStatus["Fail"] = "fail";
    TestStatus["Pass"] = "pass";
})(TestStatus || (TestStatus = {}));
var Size;
(function(Size) {
    Size["ExtraSmall"] = "xs";
    Size["Small"] = "sm";
    Size["Medium"] = "md";
    Size["Large"] = "lg";
    Size["ExtraLarge"] = "xl";
    Size["ExtraExtraLarge"] = "2xl";
})(Size || (Size = {}));
var LoadingStatus;
(function(LoadingStatus) {
    LoadingStatus["Loading"] = "loading";
    LoadingStatus["Complete"] = "complete";
})(LoadingStatus || (LoadingStatus = {}));


/***/ }),

/***/ 11069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"button_main___eQSM","loader":"button_loader__U44JW","label":"button_label__K7r_v","rotate":"button_rotate__kRBLq","loader-container":"button_loader-container__Ik9J_","loader-dots":"button_loader-dots___PKOj","loaderDots":"button_loaderDots___4DhB","phAnimation":"button_phAnimation__XeQ3d"};

/***/ }),

/***/ 84541:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"footer_main__zWXA6","hide":"footer_hide__1sdWi","wrapper":"footer_wrapper__Oh_9z","trustpilot":"footer_trustpilot__prDuu","navigation":"footer_navigation__0vP_M","list":"footer_list___73_r","link":"footer_link__uoKOq","social":"footer_social__lgWqz","accounts":"footer_accounts__4otbO","facebook":"footer_facebook__1k29k","instagram":"footer_instagram__8J0DN","x":"footer_x__9GL_m","youtube":"footer_youtube__YeUaL","linkedin":"footer_linkedin__RjfvQ","tiktok":"footer_tiktok__uTAhG","stacked":"footer_stacked__mOQSO","popular":"footer_popular___H_lb","legal":"footer_legal__J1PY8","affiliates":"footer_affiliates__pBDUk","additional":"footer_additional__vnlbX","ring":"footer_ring__0D7y9","phAnimation":"footer_phAnimation__5Ftxv"};

/***/ }),

/***/ 14327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__jP52i","is-full-width":"link_is-full-width___RhFm","phAnimation":"link_phAnimation__wE867"};

/***/ }),

/***/ 504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"newsletter-widget_main__oKvzs","form-wrapper":"newsletter-widget_form-wrapper__BzOO4","notification":"newsletter-widget_notification__EQFD0","notification--icon":"newsletter-widget_notification--icon__goNyl","form":"newsletter-widget_form__xg4Px","title":"newsletter-widget_title__a_kqZ","large":"newsletter-widget_large__0DvdK","paragraph":"newsletter-widget_paragraph__qgSNK","phAnimation":"newsletter-widget_phAnimation__m6z4t"};

/***/ }),

/***/ 98547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"text-input_main__mXMTo","box":"text-input_box__Wtjs_","input":"text-input_input__t__VH","label":"text-input_label__1LsbV","foot":"text-input_foot__gko_I","with-button":"text-input_with-button__Lh6hs","validation":"text-input_validation__32H_P","tests":"text-input_tests__XEYhx","test":"text-input_test__e87uJ","icon-default":"text-input_icon-default__oVY_r","icon-fail":"text-input_icon-fail__YHJNr","icon-pass":"text-input_icon-pass__25gAD","password":"text-input_password__N8xxl","phAnimation":"text-input_phAnimation__zUNac"};

/***/ }),

/***/ 14667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trustpilot":"trustpilot_trustpilot__1hPn1","phAnimation":"trustpilot_phAnimation__JhCx9"};

/***/ })

}]);